import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { patchMockViewing } from '../../../RentalPortalViewing'
import Text from '../../../Text'
import { TextareaElement } from '../../../Textarea'
import { Widget } from '../../../Widget'
import { QA_NAME_VIEWING_PROFILE_NOTE } from '../RentalPortalViewingProfile.constants'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'
import { getCanEditViewingNote } from '../RentalPortalViewingProfile.utils'
import { RentalPortalViewingProfileOutcome } from '../RentalPortalViewingProfileOutcome'
import { RentalPortalViewingProfileRescheduleHistory } from '../RentalPortalViewingProfileRescheduleHistory'

import * as styles from './RentalPortalViewingProfileOverview.module.css'

import EditIcon from '../../../../icons/edit.svg'
import PlusIcon from '../../../../icons/plus.svg'

function RentalPortalViewingProfileOverview() {
  const { t } = useTranslation()

  const {
    handleCancelNoteEdit,
    handleEntityReload,
    handleStartNoteEdit,
    isInitiated,
    noteEditValue,
    setNoteEditValue,
    viewingData,
  } = useViewingProfileContext()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const [isSaving, setSaving] = useState(false)

  const isEditing = noteEditValue !== null

  function handleSave() {
    setSaving(true)

    return patchMockViewing(viewingData?.id, { content: noteEditValue })
      .then(() => {
        handleCancelNoteEdit()

        return handleEntityReload()
      })
      .finally(() => {
        setSaving(false)
      })
  }

  return (
    <div className={styles.RentalPortalViewingProfileOverview}>
      <Widget
        headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
        isSkeleton={!isInitiated}
        qaName={QA_NAME_VIEWING_PROFILE_NOTE}
        title={t('RentalPortal.ViewingProfileNoteTitleKey')}
      >
        <div className={styles.note}>
          {isEditing ? (
            <>
              <TextareaElement
                autoResizeHeight
                focused
                className={styles.textarea}
                disabled={isSaving}
                placeholder={t('RentalPortal.ViewingProfileNotePlaceholderKey')}
                value={noteEditValue}
                onChange={setNoteEditValue}
              />
              <div className={styles.actions}>
                <Button.Contained
                  height={BUTTON_HEIGHT_32}
                  isLoading={isSaving}
                  text={t('Modal.SaveBtnKey')}
                  onClick={handleSave}
                />
                <Button.Outlined
                  isGrey
                  disabled={isSaving}
                  height={BUTTON_HEIGHT_32}
                  text={t('Modal.CancelBtnKey')}
                  onClick={handleCancelNoteEdit}
                />
              </div>
            </>
          ) : (
            <div className={styles.actions}>
              {getCanEditViewingNote(viewingData) ? (
                <Button.Outlined
                  isGrey
                  beforeIconProps={{
                    Icon: viewingData?.content ? EditIcon : PlusIcon,
                  }}
                  height={BUTTON_HEIGHT_32}
                  tooltip={t(
                    viewingData?.content
                      ? 'Profile.EditInfoItemBtnTooltipKey'
                      : 'Profile.AddInfoItemBtnTooltipKey'
                  )}
                  onClick={handleStartNoteEdit}
                />
              ) : null}
              <Text isSecondary={!viewingData?.content}>
                {viewingData?.content ??
                  t('RentalPortal.ViewingProfileNoteEmptyKey')}
              </Text>
            </div>
          )}
        </div>
      </Widget>
      <RentalPortalViewingProfileOutcome locale={locale} timezone={timezone} />
      <RentalPortalViewingProfileRescheduleHistory
        locale={locale}
        timezone={timezone}
      />
    </div>
  )
}

export default RentalPortalViewingProfileOverview
